import { render, staticRenderFns } from "./ProductRectangle.vue?vue&type=template&id=39db5450&scoped=true&"
import script from "./ProductRectangle.vue?vue&type=script&lang=js&"
export * from "./ProductRectangle.vue?vue&type=script&lang=js&"
import style0 from "./ProductRectangle.vue?vue&type=style&index=0&id=39db5450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db5450",
  null
  
)

export default component.exports